// Shared client status definitions

// CLIENT_STATUSES is used for the manual "stato" select in client form/Wedding tab
export const CLIENT_STATUSES = [
  { value: "lead", label: "Lead", className: "bg-secondary text-neutral-700 border-border" },
  { value: "preventivo_inviato", label: "Preventivo inviato", className: "bg-amber-100 text-amber-800 border-amber-200" },
  { value: "confermata", label: "Confermata", className: "bg-emerald-100 text-emerald-700 border-emerald-200" },
  { value: "completato", label: "Completato", className: "bg-neutral-200 text-neutral-600 border-neutral-300" },
];

// Backwards-compat: legacy "completata" → "completato"
export function normalizeStatus(s) {
  if (s === "completata") return "completato";
  return s || "lead";
}

export function statusMeta(s) {
  const norm = normalizeStatus(s);
  return CLIENT_STATUSES.find((x) => x.value === norm) || CLIENT_STATUSES[0];
}

// Derived badge based on quote/contract priority (used in Clients list, ClientDetail header, Calendar)
//
// Priority:
// 1. contract.status === "firmato"  → Contratto firmato (verde)
// 2. quote.status    === "accettato"→ Accettato        (verde)
// 3. quote.status    === "inviato"  → Preventivo inviato (oro)
// 4. quote.status    === "rifiutato"→ Rifiutato         (rosso)
// 5. (default)                      → Bozza             (blu)
//
// Override: if client has been marked with workflow_status v9.44 or legacy
// status "completato", we surface that as the authoritative badge — the
// operator explicitly closed the practice and it should read TERMINATO
// even if the underlying contract is still "firmato".
export function clientBadge(client) {
  const c = client || {};
  // CRM v9.44 authoritative source
  if (c.workflow_status === "completed") {
    return {
      key: "completed",
      label: "Terminato",
      className: "bg-rose-50 text-rose-700 border-rose-200",
      dotClass: "bg-rose-500",
    };
  }
  if (c.workflow_status === "rejected") {
    return {
      key: "rejected",
      label: "Rifiutato",
      className: "bg-violet-50 text-violet-700 border-violet-200",
      dotClass: "bg-violet-500",
    };
  }
  if (normalizeStatus(c.status) === "completato") {
    return {
      key: "completato",
      label: "Terminato",
      className: "bg-rose-50 text-rose-700 border-rose-200",
      dotClass: "bg-rose-500",
    };
  }
  const cs = (c.contract || {}).status;
  const qs = (c.quote || {}).status;
  if (cs === "firmato") {
    return {
      key: "firmato",
      label: "Contratto firmato",
      className: "bg-emerald-100 text-emerald-700 border-emerald-200",
      dotClass: "bg-emerald-500",
    };
  }
  if (qs === "accettato") {
    return {
      key: "accettato",
      label: "Accettato",
      className: "bg-emerald-50 text-emerald-700 border-emerald-200",
      dotClass: "bg-emerald-400",
    };
  }
  if (qs === "inviato") {
    return {
      key: "inviato",
      label: "Preventivo inviato",
      className: "bg-amber-100 text-amber-800 border-amber-200",
      dotClass: "bg-amber-400",
    };
  }
  if (qs === "rifiutato") {
    return {
      key: "rifiutato",
      label: "Rifiutato",
      className: "bg-red-100 text-red-700 border-red-200",
      dotClass: "bg-red-500",
    };
  }
  return {
    key: "bozza",
    label: "Bozza",
    className: "bg-blue-100 text-blue-700 border-blue-200",
    dotClass: "bg-blue-500",
  };
}
